import React, { useState, useContext } from 'react'
import { useSearchParams } from 'react-router-dom'
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { Button, Input, Form } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import logo from '../../assets/logo.png'
import api from '../../services/api';
import styles from '../../services/styles';
import Cookies from 'js-cookie';
import { displayMessage } from '../../services/helper';


const { tc1, tc2, bc1, bc2 } = styles

export default function ChangePassword(props) {

    const [searchParams, setSearchParams] = useSearchParams();

    const token = localStorage.getItem('token')
    const currentUser = JSON.parse(localStorage.getItem('user'))

    const { mobile_mode } = useContext(GeneralContext)

    const [newPassword, setNewPassword] = useState(null)
    const [confirmedNewPassword, setConfirmedNewPassword] = useState(null)
    const [formRef] = Form.useForm()


    const onFinish = (values) => {

        if (!newPassword || !confirmedNewPassword) { alert(displayMessage('FILL_ALL_FIELDS_RESET_PASSWORD')); return }
        if (newPassword != confirmedNewPassword) { alert(displayMessage('PASSWORD_CONFIRMATION_FAILED')); return }        
        
        
        const payload = {id: currentUser.id, newPassword: values.new_password}

        api.auth.changePasswordForced(payload).then(
            rs => {
                if (rs.status == 200) {
                    setTimeout(() => window.location.href = "/login", 1500 ) 
                    alert(displayMessage('RESET_PASSWORD_SUCCESS'), "success")
                }
            }
        )

    }

    return (
        <div>
            <div style={{ width: '100%', height: window.innerHeight, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ flex: 1.2, height: window.innerHeight, background: 'black', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img
                        width={'30%'}
                        src={logo}
                    />
                </div>
                <div style={{ flex: 0.8, height: window.innerHeight, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, marginLeft: '5rem', alignItems: 'center' }}>
                        <div style={{ color: tc1, fontWeight: 'bold', marginBottom: 15, fontSize: mobile_mode ? 11 : 24 }}>{displayMessage('REDEFINE_PASSWORD')}</div>

                        <Form
                            name="reset_password"
                            labelCol={{ span: 25 }}
                            wrapperCol={{ span: 80 }}
                            //wrapperRow={{ span: 80 }}
                            onFinish={onFinish}
                            style={{ textAlign: 'center', width: '65%' }}
                            form={formRef}
                        >
                            <Form.Item
                                label={displayMessage('NEW_PASSWORD_SHORT')}
                                name="new_password"
                                // className={`flex-1`}
                                rules={[{ required: true, message: displayMessage('PASSWORD_MANDATORY') }]}
                            >
                                <Input
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    type="password"
                                    size='large'
                                    placeholder={displayMessage('NEW_PASSWORD_SHORT')}
                                    autoComplete="do-not-use-auto-complete"
                                    value={newPassword}
                                    onChange={
                                        e => {
                                            setNewPassword(e.target.value)
                                        }
                                    }
                                    style={{ border: 'solid 1px rgb(92, 43, 129)', height: 40 }}
                                />
                            </Form.Item>

                            <Form.Item
                                label={displayMessage('CONFIRM_PASSWORD')}
                                name="confirm_password"
                                className={`flex-1`}
                                hasFeedback
                                rules={[
                                    { 
                                        required: true, 
                                        message: displayMessage('DISPLAY_CONFIRM_PASSWORD') 
                                    },
                                    ({getFieldValue})=>({
                                        validator(_, value){
                                            if(!value || getFieldValue('new_password')=== value) {
                                                return Promise.resolve()
                                            }
                                            return Promise.reject(new Error(displayMessage('INVALID_CONFIRMED_PASSWORD')))
                                        }
                                    })
                                ]}
                            >
                                <div>
                                    <Input
                                        prefix={<LockOutlined className="site-form-item-icon" />}
                                        type="password"
                                        value={confirmedNewPassword}
                                        placeholder={displayMessage('CONFIRM_PASSWORD')}
                                        onChange={
                                            e => {
                                                setConfirmedNewPassword(e.target.value)
                                            }
                                        }
                                        style={{ border: 'solid 1px rgb(92, 43, 129)', height: 40 }}
                                    />
                                </div>

                            </Form.Item>

                            <Form.Item hasFeedback >
                                <Button type="primary" style={{ width: "100%" }} htmlType="submit">
                                    {displayMessage('REDEFINE_PASSWORD')}
                                </Button>
                            </Form.Item>

                        </Form>
                    </div>
                </div>
            </div>

        </div>
    )
}